import React, { ReactNode } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { Field } from 'react-final-form';
import Modal from '../../../common/modals/Modal';
import SearchInput from '../../../common/inputs/SearchInput';
import Button from '../../../common/Button';

type Props = {
  structureName: string;
  structureGeographicAddress: string;
  structurePCcode:string;
  onClick?: () => void;
};

type State = {
};

class StructureSelected extends React.Component<Props, State> {
  state: State = {
  };

  render(): ReactNode {
    const {
      structureName, structureGeographicAddress, structurePCcode, onClick,
    } = this.props;
    const hasAdress = structureGeographicAddress || structurePCcode;
    return (
      <div className="structure-button">
        <div className="structure-info">
          <div className="structure-name">{structureName}</div>
          {hasAdress
            && (
              <div className="structure-address">
                {structureGeographicAddress
                && (
                  <div>{structureGeographicAddress}</div>
                )}
                {structurePCcode
                && (
                  <div>{structurePCcode}</div>
                )}
              </div>
            )}
        </div>
        {onClick
          && (
            <Button
              type="third"
              i18nKey="actions.DELETE"
              onClick={onClick}
            />
          )}
      </div>
    );
  }
}

export default StructureSelected;
